import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';

function TimelineTypeSelect({ timelineType, onSelect, hasParentPortfolios }) {
  return (
    <div className="flex">
      <div className="text-muted m-r-16">Timeline Type</div>
      <ButtonToolbar style={{ width: '160px' }}>
        <DropdownButton
          bsStyle="info"
          title={
            timelineType === 'all'
              ? timelineType
              : getOrgTermsContent(timelineType)
          }
          className="btn-block text-capitalize"
          onSelect={(val) => onSelect({ timelineType: val })}
          pullRight
        >
          <MenuItem active={timelineType === 'all'} eventKey="all">
            All
          </MenuItem>
          {hasParentPortfolios && (
            <MenuItem
              active={timelineType === 'parentPortfolios'}
              eventKey="parentPortfolios"
            >
              {getOrgTermsContent('parentPortfolios')}
            </MenuItem>
          )}
          <MenuItem
            active={timelineType === 'portfolios'}
            eventKey="portfolios"
          >
            {getOrgTermsContent('portfolios')}
          </MenuItem>
          <MenuItem active={timelineType === 'projects'} eventKey="projects">
            {getOrgTermsContent('projects')}
          </MenuItem>
          <MenuItem
            active={timelineType === 'initiatives'}
            eventKey="initiatives"
          >
            {getOrgTermsContent('initiatives')}
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default TimelineTypeSelect;
